import { createContext, useCallback, useState, useContext } from 'react';

import api from '../services/api';

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const token = localStorage.getItem('@Ocariot:token');
    const user = localStorage.getItem('@Ocariot:user');
    const type = localStorage.getItem('@Ocariot:type');

    if (token && user) {
      return { token, type, user: JSON.parse(user) };
    }

    return {};
  });
  const signIn = useCallback(async ({ username, password }) => {
    const response = await api.post('session', { username, password })

    const { token, user } = response.data;

    const { type } = user;

    localStorage.setItem('@Ocariot:token', token);
    localStorage.setItem('@Ocariot:user', JSON.stringify(user));
    localStorage.setItem('@Ocariot:type', type);

    setData({ token, user, type });
    
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@Ocariot:token');
    localStorage.removeItem('@Ocariot:user');
    localStorage.removeItem('@Ocariot:type');
    setData({});
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, type: data.type, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

const useAuth = () => {
  const ctx = useContext(AuthContext);

  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return ctx;

}

export { AuthProvider, useAuth }
